module.exports = __webpack_public_path__ + "img/icon-tiktok.753f2fa3.svg";